module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_12-69c3e8fdbfc0fbfe32a086dff193650c.png";